import { FC } from "react";
import { IconWrapper } from "../IconWrapper";
import { IconProps } from "../Icons.types";

const LockFilled: FC<IconProps> = (allProps) => {
  const { svgProps: props, ...restProps } = allProps;
  return (
    <IconWrapper
      componentName="LockFilled"
      icon={
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="inherit"
          height="inherit"
          viewBox="0 0 28 28"
          fill="none"
          {...props}
        >
          <g clip-path="url(#clip0_37183_566)">
            <path d="M21.75 8.75H19.25V6.125C19.25 4.73261 18.6969 3.39726 17.7123 2.41269C16.7277 1.42812 15.3924 0.875 14 0.875C12.6076 0.875 11.2723 1.42812 10.2877 2.41269C9.30312 3.39726 8.75 4.73261 8.75 6.125V8.75H6.25C5.78587 8.75 5.34075 8.93437 5.01256 9.26256C4.68437 9.59075 4.5 10.0359 4.5 10.5V22.75C4.5 23.2141 4.68437 23.6592 5.01256 23.9874C5.34075 24.3156 5.78587 24.5 6.25 24.5H21.75C22.2141 24.5 22.6592 24.3156 22.9874 23.9874C23.3156 23.6592 23.5 23.2141 23.5 22.75V10.5C23.5 10.0359 23.3156 9.59075 22.9874 9.26256C22.6592 8.93437 22.2141 8.75 21.75 8.75ZM14 17.9375C13.7404 17.9375 13.4867 17.8605 13.2708 17.7163C13.055 17.5721 12.8867 17.3671 12.7874 17.1273C12.6881 16.8874 12.6621 16.6235 12.7127 16.3689C12.7634 16.1143 12.8884 15.8805 13.0719 15.6969C13.2555 15.5134 13.4893 15.3884 13.7439 15.3377C13.9985 15.2871 14.2624 15.3131 14.5023 15.4124C14.7421 15.5117 14.9471 15.68 15.0913 15.8958C15.2355 16.1117 15.3125 16.3654 15.3125 16.625C15.3125 16.9731 15.1742 17.3069 14.9281 17.5531C14.6819 17.7992 14.3481 17.9375 14 17.9375ZM17.5 8.75H10.5V6.125C10.5 5.19674 10.8687 4.3065 11.5251 3.65013C12.1815 2.99375 13.0717 2.625 14 2.625C14.9283 2.625 15.8185 2.99375 16.4749 3.65013C17.1313 4.3065 17.5 5.19674 17.5 6.125V8.75Z" fill="#D548EC"/>
          </g>
          <defs>
            <clipPath id="clip0_37183_566">
              <rect width="28" height="28" fill="white"/>
            </clipPath>
          </defs>
        </svg>
      }
      {...restProps}
    />
  );
};

export default LockFilled;
